var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-avatar',{attrs:{"color":_vm.membre.couleur,"size":"24px"}}),_vm._v(" "+_vm._s(_vm.nombreHeures)+"h "+_vm._s(_vm.membre.nomComplet)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }